import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'

import { ItemPageAskSellerActionPluginModel } from './types'

export const getItemPageAskSellerActionPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageAskSellerActionPluginModel => ({
  itemId: itemDto.id,
  itemUserId: itemDto.user.id,
  canBuy: itemDto.can_buy,
  canInstantBuy: itemDto.instant_buy,
  isClosed: itemDto.is_closed,
  isHidden: itemDto.is_hidden,
  isReserved: itemDto.is_reserved,
  reservedForUserId: itemDto.reservation?.to_whom_id,
})

export const getServerItemPageAskSellerActionPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageAskSellerActionPluginModel => ({
  itemId: sidebarDto.id,
  itemUserId: sidebarDto.seller_id,
  canBuy: sidebarDto.can_buy,
  canInstantBuy: sidebarDto.instant_buy,
  isClosed: sidebarDto.is_closed,
  isHidden: sidebarDto.is_hidden,
  isReserved: sidebarDto.is_reserved,
  reservedForUserId: sidebarDto.reservation?.to_whom_id,
})
